import { useSelector } from 'react-redux';
import { getMetaComponents } from '../stores/meta-components/getters';

function specialFilters(componentData = {}) {
  const newComponentData = {
    ...componentData,
  };

  if (
    newComponentData?.metaData?.title === 'Holidays' &&
    newComponentData?.data?.length
  ) {
    const data = [...newComponentData.data];

    for (let index = 0; index < data.length; index++) {
      const dataItem = data[index];

      if (!dataItem.date) {
        continue;
      }

      if (dataItem?.added === true) {
        continue;
      }

      if (!dataItem.date.includes('(Upcoming)')) {
        continue;
      }

      data[index].date = dataItem.date.replace(
        '(Upcoming)',
        '<span  data-class="MetaComponent_Holidays_upcoming">(Upcoming)</span>'
      );

      data[index].added = true;
    }

    newComponentData.data = [...data];
  }

  return newComponentData;
}

function useMetaComponentDetails(name) {
  const data = useSelector((state) => {
    const main = getMetaComponents(state);
    const component = main[name] ? main[name] : {};
    const {
      data: dataRaw = {},
      isFetching = false,
      errors = {},
      paging,
    } = component;
    const { message, status, data = [], metaData = {} } = dataRaw;

    return {
      message,
      status,
      data,
      metaData,
      isFetching,
      errors,
      paging,
    };
  });

  const specialData = specialFilters(data);

  return specialData;
}

export default useMetaComponentDetails;
